import { FunctionComponent, useEffect, useState } from 'react';
import with_user_role, { IWithUserRoleProps } from '../../containers/hocs/main/WithUserRole';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import api from '../../api';
import ServiceDetailTemplate from '../../containers/templates/ServiceDetailTemplate/ServiceDetailTemplate';
import { normalizeRelatedServices } from '../../utils/normalizeData';
import RoutesEnum from '../../enums/routes';
import { getRoleIdByUserRole } from '../../utils/role';
import { executeErrorSequence } from '../../utils/error/serviceDetail';

interface BuildDetailViewProps extends IWithUserRoleProps {}

const BuildDetailView: FunctionComponent<BuildDetailViewProps> = ({ user_role: userRole }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const [data, setData] = useState<Record<string, any> | null>(null);

  const serviceId = location.state?.serviceId;
  const catalogLink = `/${userRole}/${RoutesEnum.BUILD}`;
  const slug = params.serviceTitle || '';

  const getBuildServiceDetails = async () => {
    try {
      let response;

      if (serviceId) {
        response = await api.Content.getBuildServiceDetails(serviceId);
      } else {
        response = await api.Content.getBuildServiceDetailsBySlug(getRoleIdByUserRole(userRole), slug);
      }

      const responseData = response.data;

      if (responseData.success && responseData.data) {
        setData({
          ...responseData.data,
          relatedServices: normalizeRelatedServices(responseData.data.relatedServices, 'build', userRole),
        });
      } else {
        executeErrorSequence(responseData.errors, catalogLink, navigate);
      }
    } catch (error) {
      executeErrorSequence(error, catalogLink, navigate);
    }
  };

  useEffect(() => {
    getBuildServiceDetails();
  }, [location]);

  return (
    <ServiceDetailTemplate
      userRole={userRole}
      title={data?.name}
      description={data?.description}
      pricing={{ value: '$75', valueAfter: '/hour' }}
      relatedServices={data?.relatedServices}
      loading={data ? false : true}
    />
  );
};

export default with_user_role(BuildDetailView);
